// extracted by mini-css-extract-plugin
module.exports = {"DeleteAppointmentModal":"DeleteAppointmentModal_DeleteAppointmentModal__3yXT2"};